var _dec, _dec2, _class, _descriptor, _descriptor2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _dec13, _dec14, _dec15, _dec16, _dec17, _dec18, _dec19, _class2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11, _descriptor12, _descriptor13, _descriptor14, _descriptor15, _descriptor16, _descriptor17, _descriptor18, _descriptor19;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../../Decorators/objectArrayTrait";
import objectTrait from "../../Decorators/objectTrait";
import primitiveArrayTrait from "../../Decorators/primitiveArrayTrait";
import primitiveTrait from "../../Decorators/primitiveTrait";
import ModelTraits from "../../ModelTraits";
import LegendTraits from "../LegendTraits";
export let EnumColorTraits = (_dec = primitiveTrait({
  name: "Value",
  description: "The enumerated value to map to a color.",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Color",
  description: "The CSS color to use for the enumerated value.",
  type: "string"
}), _class = class EnumColorTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "value", _descriptor, this);
    _initializerDefineProperty(this, "color", _descriptor2, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "value", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "color", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
let TableColorStyleTraits = (_dec3 = primitiveTrait({
  name: "Style map type",
  description: 'The type of style map. Valid values are "continuous", "enum", "bin", "constant"',
  type: "string"
}), _dec4 = primitiveTrait({
  name: "Color Column",
  description: "The column to use to color points or regions.",
  type: "string"
}), _dec5 = primitiveTrait({
  name: "Null Color",
  description: "The color to use when the value is null, specified as a CSS color string.",
  type: "string"
}), _dec6 = primitiveTrait({
  name: "Outlier Color",
  description: "The color to use when the value is lies outside minimumValue and maximumValue (and therefore not shown on color scale), specified as a CSS color string. This only applies to ContinuousColorMap",
  type: "string"
}), _dec7 = primitiveTrait({
  name: "Region Color",
  description: "The color to use when the styling the region, specified as a CSS color string.",
  type: "string"
}), _dec8 = primitiveTrait({
  name: "Null Label",
  description: "The label to use in the legend for null values.",
  type: "string"
}), _dec9 = primitiveTrait({
  name: "Outlier Label",
  description: "The label to use in the legend for outlier values.",
  type: "string"
}), _dec0 = primitiveTrait({
  name: "Minimum value",
  description: "The minimum value to use when creating ColorMaps. This is only applied for `scalar` columns.",
  type: "number"
}), _dec1 = primitiveTrait({
  name: "Maximum value",
  description: "The maximum value to use when creating ColorMaps. This is only applied for `scalar` columns.",
  type: "number"
}), _dec10 = primitiveTrait({
  name: "Number of Bins",
  description: "The number of different colors to bin the data into. This property " + "is ignored if `Bin Maximums` is specified for a `scalar` column or " + "`Enum Colors` is specified for an `enum` column.",
  type: "number"
}), _dec11 = primitiveArrayTrait({
  name: "Bin Maximums",
  description: "The maximum values of the bins to bin the data into, specified as an " + "array of numbers. The first bin extends from the dataset's minimum " + "value to the first value in this array. The second bin extends " + "from the first value in this array to the second value in this " + "array. And so on. If the maximum value of the dataset is greater " + "than the last value in this array, an additional bin is added " + "automatically. This property is ignored if the `Color Column` " + "is not a scalar.",
  type: "number"
}), _dec12 = primitiveArrayTrait({
  name: "Bin Colors",
  description: "The colors to use for the bins, each specified as a CSS color " + "string. If there are more colors than bins, the extra colors are " + "ignored. If there are more bins than colors, the colors are repeated " + "as necessary.",
  type: "string"
}), _dec13 = objectArrayTrait({
  name: "Enum Colors",
  description: "The colors to use for enumerated values. This property is ignored " + "if the `Color Column` type is not `enum`.",
  type: EnumColorTraits,
  idProperty: "value"
}), _dec14 = primitiveTrait({
  name: "Color Palette",
  description: "The name of a [ColorBrewer](http://colorbrewer2.org/) palette to use when mapping values to colors. This property is ignored if `Bin Colors` is defined and has enough colors for all bins, or if `Enum Colors` is defined. The default value depends on the type of the `Color Column` and on the data. Scalar columns that cross zero will use the diverging purple-to-orange palette `PuOr`. Scala columns that do not cross zero will use the sequential Red palette `Reds`. All other scenarios will use the 21 color `HighContrast` palette.\n      D3 color schemes are also supported (https://github.com/d3/d3-scale-chromatic) - but without `scheme` or `interpolate` string (for example - to use `interpolateViridis` - set `colorPalette = Viridis`).\n      This is case sensitive.\n      ",
  type: "string"
}), _dec15 = primitiveTrait({
  name: "Legend Ticks",
  description: "The number of tick marks (in addition to the top and bottom) to show on the legend for Continuous color scales",
  type: "number"
}), _dec16 = objectTrait({
  name: "Legend",
  description: "The legend to show with this style. If not specified, a suitable " + "is created automatically from the other parameters.",
  type: LegendTraits
}), _dec17 = primitiveTrait({
  name: "Z-score filter",
  description: "Treat values outside of specified z-score as outliers, and therefore do not include in color scale. This value is magnitude of z-score - it will apply to positive and negative z-scores. For example a value of `2` will treat all values that are 2 or more standard deviations from the mean as outliers. This must be defined for it to be enabled. This will be ignored if `minimumValue` or `maximumValue` have been set",
  type: "number"
}), _dec18 = primitiveTrait({
  name: "Z-score filter enabled",
  description: "True, if z-score filter is enabled.",
  type: "boolean"
}), _dec19 = primitiveTrait({
  name: "Range filter",
  description: "This is applied after the `zScoreFilter`. It is used to effectively 'disable' the zScoreFilter if it doesn't cut at least the specified percentage of the range of values (for both minimum and maximum value). For example if `rangeFilter = 0.2`, then the zScoreFilter will only be effective if it cuts at least 20% of the range of values from the minimum and maximum value",
  type: "number"
}), _class2 = class TableColorStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "mapType", _descriptor3, this);
    _initializerDefineProperty(this, "colorColumn", _descriptor4, this);
    _initializerDefineProperty(this, "nullColor", _descriptor5, this);
    _initializerDefineProperty(this, "outlierColor", _descriptor6, this);
    _initializerDefineProperty(this, "regionColor", _descriptor7, this);
    _initializerDefineProperty(this, "nullLabel", _descriptor8, this);
    _initializerDefineProperty(this, "outlierLabel", _descriptor9, this);
    // @primitiveTrait({
    //   name: "Bin Method",
    //   description:
    //     "The method for quantizing color. For numeric columns, valid values are:\n\n" +
    //     "  * `auto` (default)\n" +
    //     "  * `ckmeans`\n" +
    //     "  * `quantile`\n" +
    //     "  * `none` (equivalent to `Number of Bins`=0)\n\n" +
    //     "For enumerated columns, valid values are:\n\n" +
    //     "  * `auto` (default)\n" +
    //     "  * `top`\n" +
    //     "  * `cycle`",
    //   type: "string"
    // })
    // binMethod: string = "auto";
    _initializerDefineProperty(this, "minimumValue", _descriptor0, this);
    _initializerDefineProperty(this, "maximumValue", _descriptor1, this);
    _initializerDefineProperty(this, "numberOfBins", _descriptor10, this);
    _initializerDefineProperty(this, "binMaximums", _descriptor11, this);
    _initializerDefineProperty(this, "binColors", _descriptor12, this);
    _initializerDefineProperty(this, "enumColors", _descriptor13, this);
    _initializerDefineProperty(this, "colorPalette", _descriptor14, this);
    _initializerDefineProperty(this, "legendTicks", _descriptor15, this);
    _initializerDefineProperty(this, "legend", _descriptor16, this);
    _initializerDefineProperty(this, "zScoreFilter", _descriptor17, this);
    _initializerDefineProperty(this, "zScoreFilterEnabled", _descriptor18, this);
    _initializerDefineProperty(this, "rangeFilter", _descriptor19, this);
  }
}, _descriptor3 = _applyDecoratedDescriptor(_class2.prototype, "mapType", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class2.prototype, "colorColumn", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class2.prototype, "nullColor", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "outlierColor", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "regionColor", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "#02528d";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "nullLabel", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor9 = _applyDecoratedDescriptor(_class2.prototype, "outlierLabel", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class2.prototype, "minimumValue", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class2.prototype, "maximumValue", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class2.prototype, "numberOfBins", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "binMaximums", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "binColors", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "enumColors", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "colorPalette", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor15 = _applyDecoratedDescriptor(_class2.prototype, "legendTicks", [_dec15], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 7;
  }
}), _descriptor16 = _applyDecoratedDescriptor(_class2.prototype, "legend", [_dec16], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor17 = _applyDecoratedDescriptor(_class2.prototype, "zScoreFilter", [_dec17], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor18 = _applyDecoratedDescriptor(_class2.prototype, "zScoreFilterEnabled", [_dec18], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor19 = _applyDecoratedDescriptor(_class2.prototype, "rangeFilter", [_dec19], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0.3;
  }
}), _class2);
export { TableColorStyleTraits as default };